import PropTypes from "prop-types";
import Button from "./Button";
import FontAwesome from "../../icon/FontAwesome";

const ButtonDelete = (props) => {
  const { children, ...attribute } = props;
  return (
    <Button color="danger" {...attribute}>
      <FontAwesome fa="trash" /> {children}
    </Button>
  );
};

ButtonDelete.propTypes = {
  children: PropTypes.any,
};

ButtonDelete.defaultProps = {};

export default ButtonDelete;
